import React from 'react';
import { ImageOff } from 'lucide-react';

const PhotoPlaceholder = ({ aspectRatio = 'aspect-[4/3]', className = '' }) => (
  <div
    data-testid="photo-placeholder"
    className={`relative ${aspectRatio} ${className} bg-gray-100 flex flex-col items-center justify-center text-gray-400 border border-dashed border-gray-300`}
  >
    <ImageOff className="h-10 w-10 mb-3" />
    <p className="text-sm font-semibold uppercase tracking-wide">Photos Coming Soon</p>
  </div>
);

export default PhotoPlaceholder;
